/* eslint-disable jsdoc/check-param-names */
import React, { useState } from 'react';
// prettier-ignore
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, ThemeProvider} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelIcon from '@mui/icons-material/Cancel';
import { buttonsTheme } from './_theme.jsx';

/**
 * Generic Error alert when an error is returned by the backend
 * @param { boolean} open
 * @param {function(): void} setOpen
 * @param {function(): void} onClose
 * @param {string} title
 * @param {string} mainLine
 * @param {string} smallLine1
 * @param {string} smallLine2
 * @returns {React.ReactElement}
 * @class
 */
// prettier-ignore
export const BackendErrorAlert = ({ open, setOpen, onClose, title = 'Backend Error.', mainLine, smallLine1, smallLine2 }) => {
	if(open === undefined) { // have the option to control open state from outside the component
		[open, setOpen] = useState(true);
	}

	const handleClose = () => {
	    if(setOpen !== undefined) {
	    	setOpen(false);
		}
		onClose();
	}

	return (
		<ThemeProvider theme={buttonsTheme} style={{ width: '50%' }}>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					<IconButton
						aria-label="close"
						onClick={handleClose}
						sx={{
							position: 'absolute',
							right: 8,
							top: 8,
						}}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					<div className={'flex-column-container'}>
						<IconButton
							aria-label="error"
							sx={{ color: "rgb(189,67,53)", transform: 'scale(4)', marginBottom: '3vh' }}
							size='large'
						>
							<CancelIcon />
						</IconButton>
						<div style={{ color: "rgb(91,99,102)", fontSize: '2rem', marginBottom: '3vh' }}>{title}</div>
						<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
							<div style={{ fontSize: '1.5rem', color: 'rgb(91,99,102)', marginBottom: '3vh' }}>{mainLine}</div>
							{smallLine1 !== undefined && <div style={{ fontSize: '0.7rem', color: 'rgb(91,99,102)', marginBottom: '2vh' }}>{smallLine1}</div>}
							{smallLine2 !== undefined && <div style={{ fontSize: '0.7rem', color: 'rgb(91,99,102)', marginBottom: '2vh' }}>{smallLine2}</div>}
						</div>
					</div>
				</DialogContent>
				<DialogActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
					<Button variant='contained' color='primary' sx={{marginBottom: '2vh'}} onClick={handleClose}>Close</Button>
				</DialogActions>
			</Dialog>
		</ThemeProvider>
	);
}

BackendErrorAlert.FETCH_EXPLANATION = 'Some data could not be fetched.';

BackendErrorAlert.NO_RESULTS_EXPLANATION = 'No results returned.';

BackendErrorAlert.CHANGE_CRITERIA = 'Please change the search criteria.';

BackendErrorAlert.CHANGE_EXPLANATION = 'An error happened when submitting the changes.';

BackendErrorAlert.PERMISSION_REASON = 'This may be a permission restriction. Please contact the project administrator.';
